/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ResponseEntityCreated } from '../models/ResponseEntityCreated'
import type { ResponseFlatFeeCalendar } from '../models/ResponseFlatFeeCalendar'
import type { ResponseFlatFeeReservation } from '../models/ResponseFlatFeeReservation'
import type { ResponseFlatFeeReservationList } from '../models/ResponseFlatFeeReservationList'
import type { ResponseFlatFeeSite } from '../models/ResponseFlatFeeSite'

import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'

export class FlatFeeService {
  /**
   * Pobiera pełną serwisów z reklamami Flat Fee
   * @returns ResponseFlatFeeSite Lista serwisów
   * @throws ApiError
   */
  public static flatFeeSiteList(): CancelablePromise<
    Array<ResponseFlatFeeSite>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/flat-fee/sites',
    })
  }

  /**
   * Pobiera pełną serwisów z reklamami Flat Fee
   * @returns ResponseFlatFeeCalendar Lista serwisów
   * @throws ApiError
   */
  public static flatFeeProducts({
    siteId,
    startDate,
    endDate,
    shopId,
  }: {
    /**
     * identyfikator serwisu(modułu) flat fee
     */
    siteId: number
    /**
     * data początkowa
     */
    startDate: string
    /**
     * data końcowa
     */
    endDate: string
    shopId: number
  }): CancelablePromise<ResponseFlatFeeCalendar> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/flat-fee/products/{siteId}',
      path: {
        siteId: siteId,
      },
      query: {
        startDate: startDate,
        endDate: endDate,
        shopId: shopId,
      },
    })
  }

  /**
   * Pobiera dane rezerwacji Flat Fee z dukata
   * @returns any Dane rezerwacji Flat Fee lub id kampanii flat fee, która została stworzona na podstawie rezerwacji
   * @throws ApiError
   */
  public static getFlatFeeReservation({
    reservationId,
    siteId,
  }: {
    /**
     * identyfikator rezerwacji flat fee w dukacie
     */
    reservationId: number
    siteId: number
  }): CancelablePromise<ResponseFlatFeeReservation | ResponseEntityCreated> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/flat-fee/reservations/{reservationId}',
      path: {
        reservationId: reservationId,
      },
      query: {
        siteId: siteId,
      },
    })
  }

  /**
   * Pobiera liste wszystkich rezerwacji Flat Fee (z dukata i z ads)
   * @returns ResponseFlatFeeReservationList Lista rezerwacji Flat Fee z Dukata i Adsów
   * @throws ApiError
   */
  public static getFlatFeeReservations({
    shopId,
    startDate,
    endDate,
  }: {
    shopId: number
    /**
     * data początkowa
     */
    startDate: string
    /**
     * data końcowa
     */
    endDate: string
  }): CancelablePromise<ResponseFlatFeeReservationList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/flat-fee/reservations',
      query: {
        shopId: shopId,
        startDate: startDate,
        endDate: endDate,
      },
    })
  }
}
